import { Component, OnInit, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { AuthService } from '../../auth/auth.service';
import { User } from '../../auth/user';
import { DropdownMenuItem } from '../../components/dropdown-menu/dropdown-menu.component';
import { routes } from '../../routes/routes';

@Component({
  selector: 'app-onboarding-page',
  templateUrl: './onboarding-page.component.html',
  styleUrl: './onboarding-page.component.scss',
})
export class OnboardingPageComponent implements OnInit {
  brandRegistrationDisabled = signal(environment.disableBrandRegistration);
  currentUser$: Observable<User | null>;

  menuItems: DropdownMenuItem[] = [];

  protected readonly routes = routes;

  constructor(
    private authService: AuthService,
    private translateService: TranslateService,
  ) {
    this.currentUser$ = authService.currentUser$;
  }

  ngOnInit() {
    this.menuItems.push({ id: 'logout', title: this.translateService.instant('LABEL.LOGOUT') });
  }

  getLabel(user: User): string {
    if (user.name) {
      return `${user.name} (${user.email})`;
    }

    return user.email;
  }

  async onMenuItemClicked(item: DropdownMenuItem) {
    if (item.id === 'logout') {
      await this.authService.logout();
    }
  }
}
